var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"ml-n4 ml-md-0",attrs:{"text":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-arrow-left")]),_c('span',{class:{
      'text-caption text-none': true,
      'black--text': !_vm.$mobileBreakpoint,
    }},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }